import styled from 'styled-components'

export const DotAlert = styled.span`
  display: inline-block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background-color: var(--error500);
  margin-left: 4px;
`
export const MyTicketsWrapper = styled.div`
  padding: 0 24px;
`
